import { useState } from "react";

const KmLogModal = ({ vehicle, onClose, onSave }) => {
  const [formData, setFormData] = useState({
    km: '',
    date: new Date().toISOString().split('T')[0],
    trip_type: 'business',
    destination: '',
    purpose: '',
    notes: ''
  });

  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4" onClick={onClose}>
      <div className="bg-slate-800 rounded-xl border border-slate-700 w-full max-w-lg" onClick={e => e.stopPropagation()}>
        <div className="p-6 border-b border-slate-700">
          <h3 className="text-xl font-bold text-white">Registar Quilómetros</h3>
          <p className="text-sm text-slate-400 mt-1">{vehicle.brand} {vehicle.model} - {vehicle.license_plate}</p>
          <p className="text-sm text-blue-400 mt-1">Km atual: {vehicle.current_km?.toLocaleString('pt-PT')} km</p>
        </div>
        <div className="p-6 space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-slate-300 mb-1">Nova Quilometragem *</label>
              <input
                type="number"
                value={formData.km}
                onChange={e => setFormData({...formData, km: parseInt(e.target.value)})}
                className="w-full px-3 py-2 rounded-lg bg-slate-700 border border-slate-600 text-white"
                placeholder="Ex: 45000"
                min={vehicle.current_km || 0}
                data-testid="km-input"
                required
              />
              <p className="text-xs text-slate-500 mt-1">Mínimo: {vehicle.current_km?.toLocaleString('pt-PT')} km</p>
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-300 mb-1">Data</label>
              <input
                type="date"
                value={formData.date}
                onChange={e => setFormData({...formData, date: e.target.value})}
                className="w-full px-3 py-2 rounded-lg bg-slate-700 border border-slate-600 text-white"
              />
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-300 mb-1">Tipo de Viagem</label>
            <select
              value={formData.trip_type}
              onChange={e => setFormData({...formData, trip_type: e.target.value})}
              className="w-full px-3 py-2 rounded-lg bg-slate-700 border border-slate-600 text-white"
            >
              <option value="business">Serviço / Profissional</option>
              <option value="personal">Pessoal</option>
              <option value="mixed">Misto</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-300 mb-1">Destino</label>
            <input
              type="text"
              value={formData.destination}
              onChange={e => setFormData({...formData, destination: e.target.value})}
              className="w-full px-3 py-2 rounded-lg bg-slate-700 border border-slate-600 text-white"
              placeholder="Ex: Lisboa, Porto, Cliente XYZ"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-300 mb-1">Motivo / Finalidade</label>
            <input
              type="text"
              value={formData.purpose}
              onChange={e => setFormData({...formData, purpose: e.target.value})}
              className="w-full px-3 py-2 rounded-lg bg-slate-700 border border-slate-600 text-white"
              placeholder="Ex: Reunião com cliente, Formação"
            />
          </div>
        </div>
        <div className="p-6 border-t border-slate-700 flex justify-end gap-3">
          <button onClick={onClose} className="px-4 py-2 rounded-lg bg-slate-700 text-white hover:bg-slate-600">
            Cancelar
          </button>
          <button
            onClick={() => onSave(formData)}
            disabled={!formData.km}
            className="px-4 py-2 rounded-lg bg-emerald-600 text-white hover:bg-emerald-500 disabled:opacity-50"
            data-testid="submit-km-btn"
          >
            Registar
          </button>
        </div>
      </div>
    </div>
  );
};

export default KmLogModal;
